import { render } from "./KontaktView.vue?vue&type=template&id=50710c10&scoped=true"
import script from "./KontaktView.vue?vue&type=script&lang=js"
export * from "./KontaktView.vue?vue&type=script&lang=js"

import "./KontaktView.vue?vue&type=style&index=0&id=50710c10&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Development\\saska-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50710c10"]])

export default __exports__